/** Minimal hast node shape: only what is needed to read source positions and set properties. */
interface SourcePositionedNode {
  type: string;
  tagName?: string;
  position?: { start: { line: number }; end: { line: number } };
  properties?: Record<string, unknown>;
  children?: SourcePositionedNode[];
}

const SOURCE_LINE_TAG_NAMES = new Set([
  'p',
  'li',
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'blockquote',
  'pre',
  'table',
  'tr',
]);

/**
 * Rehype plugin: marks block elements with the 1-based source lines they were rendered from, as
 * `data-source-line-start` / `data-source-line-end`.
 */
export const rehypeSourceLines = () => (tree: SourcePositionedNode) => {
  const visit = (node: SourcePositionedNode) => {
    if (node.type === 'element' && node.tagName && SOURCE_LINE_TAG_NAMES.has(node.tagName) && node.position) {
      node.properties = {
        ...node.properties,
        dataSourceLineStart: node.position.start.line,
        dataSourceLineEnd: node.position.end.line,
      };
    }

    node.children?.forEach(visit);
  };

  visit(tree);
};
